import { render, staticRenderFns } from "./FormControlTypeCollectionFilters.vue?vue&type=template&id=6ac163d3&scoped=true"
import script from "./FormControlTypeCollectionFilters.vue?vue&type=script&lang=js"
export * from "./FormControlTypeCollectionFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac163d3",
  null
  
)

export default component.exports